import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import Button from 'orionsoft-parts/lib/components/Button'

@withRouter
export default class NoFields extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    document: PropTypes.object
  }

  state = {}

  render() {
    return (
      <div className={styles.content}>
        <div className="content">
          <div className={styles.noItems}>No existen campos con nombres asignados</div>
          <div className={styles.button}>
            <Button onClick={() => this.props.router.push(`/documents/${this.props.document._id}`)}>
              volver
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/FillNameFields/NoFields/index.js